import { useEffect, useState } from "react";
import "./affiliateModal.styles.scss";
import { addAffiliateAccount } from "./affiliateModal.utils";
const affiliateFormInitial = {
  accountName: "",
  accountEmail: "",
  accountType: "",
  hotelID: "",
  startDate: "",
};

const AffiliateModal = ({ accountTypeValue }) => {
  const [affiliateFormFields, setAffiliateFormFields] =
    useState(affiliateFormInitial);
  const { accountName, accountEmail, hotelID } = affiliateFormFields;
  useEffect(() => {
    const tempDate = new Date();
    const dateString = tempDate.toDateString();
    setAffiliateFormFields({
      ...affiliateFormFields,
      startDate: dateString,
      accountType: accountTypeValue,
    });
  }, [accountTypeValue]);
  const handleSubmit = (event) => {
    event.preventDefault();
    addAffiliateAccount(affiliateFormFields);
  };
  const handleChange = (event) => {
    const { value, name } = event.target;
    setAffiliateFormFields({ ...affiliateFormFields, [name]: value });
  };
  return (
    <div className="affiliate-modal-container">
      <div className="affiliate-modal-box">
        <span className="am-title">{accountTypeValue} Account</span>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={accountName}
            name="accountName"
            placeholder="Account Name"
            onChange={handleChange}
            className="am-form-input"
          />
          <input
            type="text"
            value={accountEmail}
            name="accountEmail"
            placeholder="Email Address"
            onChange={handleChange}
            className="am-form-input"
          />
          <input
            type="text"
            value={hotelID}
            name="hotelID"
            placeholder="Unique ID(Provided by restaurant admin)"
            onChange={handleChange}
            className="am-form-input"
          />
          <button type="submit" className="am-form-submit">
            Access Account
          </button>
        </form>
      </div>
    </div>
  );
};
export default AffiliateModal;
